import React, { useEffect, useRef } from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import './Stock.css'

const Stock = () => {
    const sensexWidgetRef = useRef(null);
  const goldWidgetRef = useRef(null);
  const oilWidgetRef = useRef(null);
  const eurusdWidgetRef = useRef(null);
  const nikkiWidgetRef = useRef(null);
  const nasdaqWidgetRef = useRef(null);
  const ftseWidgetRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    // Load TradingView widget script for sensex
    if (sensexWidgetRef.current) {
        const sensexScript = document.createElement('script');
        sensexScript.type = 'text/javascript';
        sensexScript.src = 'https://s3.tradingview.com/external-embedding/embed-widget-single-quote.js';
        sensexScript.async = true;
        sensexScript.innerHTML = `
          {
            "symbol": "INDEX:SENSEX",
            "width": 350,
            "isTransparent": false,
            "colorTheme": "light",
            "locale": "in"
          }
        `;
        sensexWidgetRef.current.appendChild(sensexScript);
        // sensexWidgetRef.current.style.borderRadius = '10px';
      }
  

    // Load TradingView widget script for EUR/USD
    if (eurusdWidgetRef.current) {
      const eurusdScript = document.createElement('script');
      eurusdScript.type = 'text/javascript';
      eurusdScript.src = 'https://s3.tradingview.com/external-embedding/embed-widget-single-quote.js';
      eurusdScript.async = true;
      eurusdScript.innerHTML = `
        {
          "symbol": "FX:EURUSD",
          "width": 350,
          "isTransparent": false,
          "colorTheme": "light",
          "locale": "in"
        }
      `;
      eurusdWidgetRef.current.appendChild(eurusdScript);
    }
    // Load TradingView widget script for nikki
    if (nikkiWidgetRef.current) {
        const nikkiScript = document.createElement('script');
        nikkiScript.type = 'text/javascript';
        nikkiScript.src = 'https://s3.tradingview.com/external-embedding/embed-widget-single-quote.js';
        nikkiScript.async = true;
        nikkiScript.innerHTML = `
          {
            "symbol": "SPREADEX:NIKKEI",
            "width": 350,
            "isTransparent": false,
            "colorTheme": "light",
            "locale": "in"
          }
        `;
        nikkiWidgetRef.current.appendChild(nikkiScript);
      }
      // Load TradingView widget script for US ftse
    if (nasdaqWidgetRef.current) {
        const ftseScript = document.createElement('script');
        ftseScript.type = 'text/javascript';
        ftseScript.src = 'https://s3.tradingview.com/external-embedding/embed-widget-single-quote.js';
        ftseScript.async = true;
        ftseScript.innerHTML = `
          {
            "symbol": "SPREADEX:FTSE",
            "width": 350,
            "isTransparent": false,
            "colorTheme": "light",
            "locale": "in"
          }
        `;
        ftseWidgetRef.current.appendChild(ftseScript);
      }
       // Load TradingView widget script for US nasdaq
      if (nasdaqWidgetRef.current) {
        const nasdaqScript = document.createElement('script');
        nasdaqScript.type = 'text/javascript';
        nasdaqScript.src = 'https://s3.tradingview.com/external-embedding/embed-widget-single-quote.js';
        nasdaqScript.async = true;
        nasdaqScript.innerHTML = `
          {
            "symbol": "NASDAQ:IXIC",
            "width": 350,
            "isTransparent": false,
            "colorTheme": "light",
            "locale": "in"
          }
        `;
        nasdaqWidgetRef.current.appendChild(nasdaqScript);
      }

       // Load TradingView widget script for Gold
    if (goldWidgetRef.current) {
        const goldScript = document.createElement('script');
        goldScript.type = 'text/javascript';
        goldScript.src = 'https://s3.tradingview.com/external-embedding/embed-widget-single-quote.js';
        goldScript.async = true;
        goldScript.innerHTML = `
          {
            "symbol": "TVC:GOLD",
            "width": 350,
            "isTransparent": false,
            "colorTheme": "light",
            "locale": "in"
          }
        `;
        goldWidgetRef.current.appendChild(goldScript);
      }
  
      // Load TradingView widget script for US Oil
      if (oilWidgetRef.current) {
        const oilScript = document.createElement('script');
        oilScript.type = 'text/javascript';
        oilScript.src = 'https://s3.tradingview.com/external-embedding/embed-widget-single-quote.js';
        oilScript.async = true;
        oilScript.innerHTML = `
          {
            "symbol": "TVC:USOIL",
            "width": 350,
            "isTransparent": false,
            "colorTheme": "light",
            "locale": "in"
          }
        `;
        oilWidgetRef.current.appendChild(oilScript);
      }

    return () => {
      // Clean up scripts on component unmount
      if (sensexWidgetRef.current) {
        sensexWidgetRef.current.innerHTML = '';
      }
      if (eurusdWidgetRef.current) {
        eurusdWidgetRef.current.innerHTML = '';
      }
      if (nikkiWidgetRef.current) {
        nikkiWidgetRef.current.innerHTML = '';
      }
      if (nasdaqWidgetRef.current) {
        nasdaqWidgetRef.current.innerHTML = '';
      }
      if (ftseWidgetRef.current) {
        ftseWidgetRef.current.innerHTML = '';
      }
      if (goldWidgetRef.current) {
        goldWidgetRef.current.innerHTML = '';
      }
      if (oilWidgetRef.current) {
        oilWidgetRef.current.innerHTML = '';
      }
    };
  }, []);
//   const containerRef = useRef(null);

const scrollLeft = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({
        left: -150, 
        behavior: 'smooth',
      });
    }
  };

  const scrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({
        left: 150, 
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="tradingview-widgets-container">
        <div className='stock-main'>
            <div className='stock-button-left-main'>
                <button className='stock-button-left' onClick={scrollLeft} ><ArrowBackIosIcon/></button>
            </div>
        <div ref={containerRef} className="tradingview-widgets-content" >
            <div ref={sensexWidgetRef} className="tradingview-widget-container__widget" ></div>
            <div ref={nikkiWidgetRef} className="tradingview-widget-container__widget"></div>
            <div ref={ftseWidgetRef} className="tradingview-widget-container__widget"></div>
            <div ref={nasdaqWidgetRef} className="tradingview-widget-container__widget"></div>
            <div ref={oilWidgetRef} className="tradingview-widget-container__widget"></div>
            <div ref={eurusdWidgetRef} className="tradingview-widget-container__widget"></div>
            <div ref={goldWidgetRef} className="tradingview-widget-container__widget"></div>
        </div>
        <div className='stock-button-right-main'>
            <button onClick={scrollRight} className='stock-button-right'><ArrowForwardIosIcon/></button>
        </div>
        </div>
        <div className="tradingview-widget-copyright"></div>
    </div>

  );
};

export default Stock;